import type { PlanPrices } from './billingApi'

export type ReportPackId = 'single' | 'pack2' | 'pack3'

export interface ReportPackOption {
  id: ReportPackId
  reports: number
  priceCents: number
  /** Percent saved against buying the same number of single reports. */
  savingsPercent: number
}

const PACK_SIZES: Record<ReportPackId, number> = { single: 1, pack2: 2, pack3: 3 }

/** One-time report options that have a live price, smallest first. Packs the backend did not price are left out. */
export function availableReportPacks(prices: PlanPrices): ReportPackOption[] {
  const single = prices.single
  return (Object.keys(PACK_SIZES) as ReportPackId[])
    .filter((id) => prices[id] != null)
    .map((id) => {
      const reports = PACK_SIZES[id]
      const priceCents = prices[id] as number
      const savingsPercent = single && reports > 1 ? Math.round((1 - priceCents / (single * reports)) * 100) : 0
      return { id, reports, priceCents, savingsPercent }
    })
}

export function formatUsd(cents: number): string {
  return cents % 100 === 0 ? `$${cents / 100}` : `$${(cents / 100).toFixed(2)}`
}
